define('views/microshop-page-view',[
  'jquery',
  'pikaday',
  'moment',

  'utils/view',
  'utils/toast',
  'utils/debounce',

  'connections/microshop-connection'
], function ($, Pikaday, moment, View, toast, debounce, MicroshopConnection) {
  var _this;
  var MicroshopPageView = (function () {
    /**
     * Initializes the shop bindings.
     *
     * @method _init
     * @private
     */
    function MicroshopPageView(container) {
      _this = this;
      _this.container = container;
      _this.shopId = container.data('shopId');
      _this.addProducts = {};
      _this.orderPriceSettings = {};
    }

    //#region COMMON

    MicroshopPageView.prototype.init = function () {
      _this.initGeneral();
      _this.initContent();
      _this.initTheme();
      _this.initProducts();
      _this.initFiles();
      _this.initOrderSettings();
    };

    MicroshopPageView.prototype.getAddedProducts = function () {
      return Object.keys(_this.addProducts).map(function (key) {
        return _this.addProducts[key];
      });
    };

    MicroshopPageView.prototype.bindForm = function ($form, action, cb) {
      var $saveBtn = $form.find('[data-form-save-button]');

      $form.on('change', ':input:not([data-addon-new])', function () {
        if ($(this).is('[data-invalidate-form]')) {
          $saveBtn.attr('disabled', $(this).data('invalidateForm'));
        } else {
          $saveBtn.attr('disabled', false);
        }
      });

      $form.on('click', '[data-action-delete], [data-action-add], [data-action-change]', function () {
        $saveBtn.attr('disabled', false);
      });

      $form.on('submit', function (e) {
        e.preventDefault();

        var formData = new FormData($form.get(0));
        formData.append('shopId', _this.shopId);

        $saveBtn.attr('disabled', true);
        action(formData).then(function (resData, __, req) {
          if (req.status === 200) {
            toast.queue(req.statusText, 5000);

            if (cb) cb(resData);
          }
        });
      });
    };
    //#endregion

    //#region GENERAL

    MicroshopPageView.prototype.initGeneral = function () {
      _this.initDatePicker();
      _this.bindUriInputChanged();
      _this.bindSecuritySelectionChanged();
      _this.displayExtraSecurityInputs($('[data-security-radio]:checked').val());

      _this.bindForm($('#generalForm'), MicroshopConnection.updateGeneral, function (res) {
        var $showWebsiteAction = $('[data-show-website-link]');
        var newUrl = 'https://' + $('#GeneralSettings_Uri').val();

        $showWebsiteAction.attr('href', newUrl);
      });
    };

    MicroshopPageView.prototype.initDatePicker = function () {
      var field = $('#GeneralSettings_ExpireDate')[0];

      if (field.value) {
        field.value = moment(field.value).format('YYYY-MM-DD');
      }

      _this.picker = new Pikaday({
        field: field,
        firstDay: 1,
        onSelect: _this.updateExpiration
      });
    };

    MicroshopPageView.prototype.bindUriInputChanged = function () {
      $('#GeneralSettings_UriPart1').on('change', _this.updateUri);
      $('#GeneralSettings_UriPart2').on('change', _this.updateUri);
      $('#GeneralSettings_UriDomain').on('change', _this.updateUri);
    };

    MicroshopPageView.prototype.bindSecuritySelectionChanged = function () {
      $('[data-security-radio]').on('change', function () {
        _this.displayExtraSecurityInputs($(this).val());
      });
    };

    MicroshopPageView.prototype.displayExtraSecurityInputs = function (selection) {
      var $securityInput = $('[data-security-hidden-input="secret"]');
      var $verificationInput = $('[data-security-hidden-input="verification"]');

      switch (selection) {
        case '1':
          $securityInput.show();
          $verificationInput.hide();
          break;
        case '2':
          $securityInput.hide();
          $verificationInput.show();
          break;
        case '3':
          $securityInput.show();
          $verificationInput.show();
          break;
        default:
          $securityInput.hide();
          $verificationInput.hide();
          break;
      }
    };

    MicroshopPageView.prototype.updateUri = function () {
      var uri1 = $('#GeneralSettings_UriPart1').val();
      var uri2 = $('#GeneralSettings_UriPart2').val();
      var uriDomain = $('#GeneralSettings_UriDomain').val();
      var shopId = _this.shopId ? _this.shopId : '';
      MicroshopConnection.validateUri(uri1, uri2, uriDomain, shopId).then(function (res) {
        if (res.status === 'error' || !res.ok) {
          toast.queueError(res.message, 5000);
        }
        _this.updateUrlLabelAndValue(res.ok, res.uri);
      });
    };

    MicroshopPageView.prototype.updateUrlLabelAndValue = function (isOk, uri) {
      if (isOk) {
        $('#GeneralSettings_Uri').data('invalidateForm', false).val(uri).trigger('change');
        $('#GeneralSettings_UriDisplay').text(uri);
      } else {
        $('#GeneralSettings_Uri').data('invalidateForm', true).val('').trigger('change');
        $('#GeneralSettings_UriDisplay').text('');
      }
    };

    MicroshopPageView.prototype.updateExpiration = function (e) {
      var pickerDate = _this.picker.getDate();
      var date = moment(pickerDate).format('YYYY-MM-DD');

      $('#ShopPageInfo_ExpireDate').val(date);
    };

    //#endregion

    //#region CONTENT

    MicroshopPageView.prototype.initContent = function () {
      _this.bindDeleteImagesButtons();

      _this.bindContentImageChanged();
      var $form = $('#contentForm');
      _this.bindForm($form, MicroshopConnection.updateContent, function (res) {
        $('#logoImg')
          .attr('src', res.logoType.url)
          .nextAll('span')
          .text(res.logoType.filename || '');

        $('[data-action-delete="logo"]').css('display', res.logoType.url ? 'inline-block' : 'none');

        $('#bgImg')
          .attr('src', res.backgroundImage.url)
          .nextAll('span')
          .text(res.backgroundImage.filename || '');
        $('[data-action-delete="bg"]').css('display', res.backgroundImage.url ? 'inline-block' : 'none');

        $('[data-content-image]').val(null);
        $form.find('.microshop-edit__deleted').removeClass('microshop-edit__deleted');
      });
    };

    MicroshopPageView.prototype.bindDeleteImagesButtons = function () {
      $hiddenLogoInput = $('#Content_LogotypeFile');
      $hiddenBgInput = $('#Content_BackgroundImageFile');

      $deleteLogoButton = $('[data-action-delete="logo"]');
      $deleteBgButton = $('[data-action-delete="bg"]');

      if ($hiddenLogoInput.val()) $deleteLogoButton.css('display', 'inline-block');

      if ($hiddenBgInput.val()) $deleteBgButton.css('display', 'inline-block');

      $deleteLogoButton.on('click', function (e) {
        e.preventDefault();
        $hiddenLogoInput.val(null);
        $(this).parent('.pinfo__form__row').addClass('microshop-edit__deleted');
      });

      $deleteBgButton.on('click', function (e) {
        e.preventDefault();
        $hiddenBgInput.val(null);
        $(this).parent('.pinfo__form__row').addClass('microshop-edit__deleted');
      });
    };

    MicroshopPageView.prototype.bindContentImageChanged = function () {
      $('[data-content-image]').on('change', function (e) {
        var fileName = e.target.files && e.target.files.length ? e.target.files[0].name : null;
        var fileNameInput = $('#' + $(e.target).data('contentImage'));
        fileNameInput.val(fileName);
      });
    };

    //#endregion

    //#region FILES

    MicroshopPageView.prototype.initFiles = function () {
      var $filesContainer = $('[data-files-container]');
      var $filesInput = $('[data-files-input]');

      _this.initFileBindings($filesContainer);

      _this.bindForm($('#filesForm'), MicroshopConnection.updateFiles, function () {
        MicroshopConnection.getFiles(_this.shopId).then(function (res) {
          $filesContainer.html(res);
          $filesInput.val(null);
          // _this.initFileBindings();
        });
      });
    };

    MicroshopPageView.prototype.initFileBindings = function ($container) {
      _this.bindDeleteFileButtons($container);
      _this.bindChangedFileInput($container);
    };

    MicroshopPageView.prototype.bindDeleteFileButtons = function ($container) {
      $container.on('click', '[data-action-delete="file"]', function (e) {
        var $filerow = $(this).parents('tr');

        // mark as deleted.
        $filerow.addClass('microshop-edit__deleted-tr');
        $(this).hide();

        // set hidden status-input to deleted
        $filerow.find('[data-file-status]').val(2);
      });
    };

    MicroshopPageView.prototype.bindChangedFileInput = function ($container) {
      $container.on('change', '[data-file-description]', function (e) {
        var $filerow = $(this).parents('tr');

        // set hidden status-input to changed
        $filerow.find('[data-file-status]').val(1);
      });
    };
    //#endregion

    //#region PRODUCTS
    MicroshopPageView.prototype.initProducts = function () {
      var $productsContainer = $('[data-products-container]');
      var $productTab = $('#tab-products');
      var $loader = $('[data-microshop-product-loader');

      function lazyLoadProducts(e) {
        MicroshopConnection.getProductSearchCategories(_this.shopId).then(function (res) {
          var $productSearchCategoriesContainer = $('[data-searchproductcategories-container]');
          $productSearchCategoriesContainer.html(res);
        });

        MicroshopConnection.getProducts(_this.shopId)
          .then(function (res) {
            $productsContainer.html(res);
          })
          .always(function () {
            $loader.slideUp();
          });
      }

      if ($productTab.is(':checked')) {
        lazyLoadProducts();
      } else {
        $productTab.one('click', lazyLoadProducts);
      }

      _this.bindForm($('#productsForm'), MicroshopConnection.updateProducts, function () {
        var productsToAdd = _this.getAddedProducts();

        if (productsToAdd.length) {
          MicroshopConnection.addProducts(_this.shopId, productsToAdd).then(function () {
            MicroshopConnection.getProducts(_this.shopId).then(function (res) {
              $productsContainer.html(res);
              _this.checkSearchRows();
            });

            _this.addProducts = [];
          });
        } else {
          MicroshopConnection.getProducts(_this.shopId).then(function (res) {
            $productsContainer.html(res);
            _this.checkSearchRows();
          });
        }
      });

      _this.initProductsSearchSection();
      _this.bindProductsListStatusChanged($productsContainer);
      _this.bindProductListPriceInputs($productsContainer);
      _this.bindProductAddonDropdown($productsContainer);
      _this.bindProductAddonCheckbox($productsContainer);
      _this.bindProductSortButtons($productsContainer);
    };

    MicroshopPageView.prototype.updatePrice = function ($product) {
      var $priceCell = $product.find('[data-price-cell]');
      var currency = $priceCell.data('currency');
      var retailPrice = $priceCell.data('retailPrice');
      var productPriceModelType = $priceCell.find('[data-product-price-input="type"]').val() || 0;
      var productPriceFixed = $priceCell.find('[data-product-price-input="fixed"]').val() || 0;
      var productPriceModifier = $priceCell.find('[data-product-price-input="modifier"]').val() || 0;

      var settings = {
        defaultPriceModelType: _this.orderPriceSettings.defaultPriceModelType,
        defaultPriceFixed: _this.orderPriceSettings.defaultPriceFixed,
        defaultPriceModifier: _this.orderPriceSettings.defaultPriceModifier,
        productPriceModelType: productPriceModelType,
        productPriceFixed: productPriceFixed,
        productPriceModifier: productPriceModifier,
        retailPrice: retailPrice,
        currency: currency
      };

      if (
        settings.productPriceModelType === 'None' ||
        (settings.productPriceModelType === 'Default' && settings.defaultPriceModelType === 'None')
      ) {
        $product.find('[data-variation-price]').hide();
      } else {
        MicroshopConnection.getPrice(_this.shopId, $.param(settings)).then(function (price) {
          $product.find('[data-variation-price]').show().text(price);
        });
      }
    };

    MicroshopPageView.prototype.checkSearchRows = function () {
      var addedVariations = $('[data-variation]')
        .map(function () {
          return $(this).data('variation');
        })
        .get();

      var $foundVariations = $('[data-search-variation]');

      $foundVariations.each(function () {
        if (addedVariations.indexOf($(this).data('searchVariation')) >= 0) {
          $(this).removeClass('icon-plus icon-minus').addClass('icon-check microshop-edit__icon-disabled');
          $(this).removeAttr('data-action-toggle-variation');
        } else {
          $(this).addClass('icon-plus').removeClass('icon-check microshop-edit__icon-disabled');
          $(this).attr('data-action-toggle-variation', false);
        }
      });
    };

    MicroshopPageView.prototype.bindProductSortButtons = function ($container) {
      $container.on('click', '[data-products-sort]:not(.microshop-edit__sort-arrow--disabled)', function () {
        var direction = $(this).data('productsSort');
        var $product = $(this).parents('[data-product]');
        var $sortInput = $product.find('[data-product-sort]');
        var $statusInputs = $product.find('[data-variation-status]');
        var currentSort = $sortInput.val();
        var oppositeDirection = direction === 'up' ? 'down' : 'up';

        var isDisabled = $product
          .find('[data-products-sort=' + oppositeDirection + ']')
          .hasClass('microshop-edit__sort-arrow--disabled');

        // Other affected product
        var $nextProduct = direction === 'up' ? $product.prev('[data-product]') : $product.next('[data-product]');
        var $nextSortInput = $nextProduct.find('[data-product-sort]');
        var $nextstatusInputs = $nextProduct.find('[data-variation-status]');
        var nextCurrentSort = $nextSortInput.val();
        var isNextDisabled = $nextProduct
          .find('[data-products-sort=' + direction + ']')
          .hasClass('microshop-edit__sort-arrow--disabled');

        // Change sort and status on affected item rows.
        $nextSortInput.val(currentSort);
        $sortInput.val(nextCurrentSort);
        $nextstatusInputs.val(1);
        $statusInputs.val(1);

        // Update GUI.
        if (direction === 'up') $nextProduct.before($product);
        else $product.before($nextProduct);

        if (isDisabled) {
          $nextProduct
            .find('[data-products-sort=' + oppositeDirection + ']')
            .addClass('microshop-edit__sort-arrow--disabled');
          $product
            .find('[data-products-sort=' + oppositeDirection + ']')
            .removeClass('microshop-edit__sort-arrow--disabled');
        }

        if (isNextDisabled) {
          $nextProduct
            .find('[data-products-sort=' + direction + ']')
            .removeClass('microshop-edit__sort-arrow--disabled');
          $product.find('[data-products-sort=' + direction + ']').addClass('microshop-edit__sort-arrow--disabled');
        }
      });
    };

    MicroshopPageView.prototype.bindProductAddonCheckbox = function ($container) {
      $container.on('click', '[data-addon-value]', function () {
        var $hiddenSelect = $(this).siblings('[data-addon-select]');
        var $option = $hiddenSelect.find('option[value=' + $(this).data('addonValue') + ']');

        // toggle hidden select bound to form.
        $option.prop('selected', !$option.prop('selected'));
        $hiddenSelect.trigger('change');

        // toggle visible label
        $(this).toggleClass('microshop-edit__addon-check--selected');
      });
    };

    MicroshopPageView.prototype.bindProductAddonDropdown = function ($container) {
      $container.on('click', '[data-addon-open-select]', function () {
        var $icon = $(this).children('[data-addon-icon]');
        var $product = $(this).parents('[data-product]');
        var $addons = $product.find('[data-addons]');

        $addons.toggleClass('hidden');
        $icon.toggleClass('icon-down-open').toggleClass('icon-up-open');
      });
    };

    MicroshopPageView.prototype.bindProductListPriceInputs = function ($container) {
      $container.on('change', '[data-product-price-input]', function () {
        var $product = $(this).parents('[data-product]');
        _this.updatePrice($product);
      });

      $container.on('change', '[data-product-price-select]', function () {
        var $fixedInput = $(this).siblings('[data-productlist-hidden-input="fixed"]');
        var $modifierInput = $(this).siblings('[data-productlist-hidden-input="modifier"]');

        switch ($(this).val()) {
          case 'Fixed':
            $fixedInput.show();
            $modifierInput.hide();
            break;
          case 'Retail':
            $fixedInput.hide();
            $modifierInput.show();
            break;
          default:
            $fixedInput.hide();
            $modifierInput.hide();
            break;
        }
      });
    };

    MicroshopPageView.prototype.bindProductsListStatusChanged = function ($container) {
      // Set status to deleted - 2
      $container.on('click', '[data-action-delete="variation"]', function () {
        var $variation = $(this).parents('[data-variation]');
        $variation.addClass('microshop-edit__deleted');
        $variation.find('input[data-variation-status]').val(2);
      });

      // Set status on all child variations to deleted - 2
      $container.on('click', '[data-action-delete="product"]', function () {
        var $product = $(this).parents('[data-product]');
        $product.addClass('microshop-edit__deleted');
        $product.find('[data-variation-status]').val(2);
      });

      // Set status on specific variation to changed - 1
      $container.on('change', '[data-variation-input]', function () {
        var $variation = $(this).parents('[data-variation]');
        $variation.find('[data-variation-status]').val(1);
      });

      // Set status on all child variations to changed - 1
      $container.on('change', '[data-product-input]', function () {
        var $product = $(this).parents('[data-product]');
        $product.find('[data-variation-status]').val(1);
      });
    };

    MicroshopPageView.prototype.initProductsSearchSection = function () {
      var $loader = $('[data-microshop-search-loader');
      var $productsSearchResultsContainer = $('[data-searchproductresults-container]');

      var $radios = $('input[type=radio][name=MicroshopSearchRadio]');
      $radios.on('change', function () {
        $('.microshop-edit__search-radio-label--selected').removeClass('microshop-edit__search-radio-label--selected');
        $(this).parent().addClass('microshop-edit__search-radio-label--selected');

        var val = $(this).val();
        $('[data-microshop-search]').hide();
        $('[data-microshop-search="' + val + '"]').show();

        if (val === 'wishlist') {
          $loader.slideDown('fast');
          // Search by wishlist - immediately on select
          MicroshopConnection.getProductsByWishList(_this.shopId)
            .then(function (res) {
              $productsSearchResultsContainer.html(res);
              _this.checkSearchRows();
            })
            .always(function () {
              $loader.slideUp('fast');
            });
        }
      });

      // Search by searchfield - on input debounced
      var searchInputHandler = debounce(function (e) {
        $loader.slideDown('fast');
        MicroshopConnection.getProductsBySearch(_this.shopId, e.target.value)
          .then(function (res) {
            $productsSearchResultsContainer.html(res);
            _this.checkSearchRows();
          })
          .always(function () {
            $loader.slideUp('fast');
          });
      }, 350);

      $('#search-products').on('input', searchInputHandler);

      // Search by category - on category select
      $('[data-searchproductcategories-container]').on('change', '#search-category', function () {
        var category = $(this).val();

        $loader.slideDown('fast');
        MicroshopConnection.getProductsByCategory(_this.shopId, category)
          .then(function (res) {
            $productsSearchResultsContainer.html(res);
            _this.checkSearchRows();
          })
          .always(function () {
            $loader.slideUp('fast');
          });
      });

      _this.bindAddProductCheckboxes($productsSearchResultsContainer);
    };

    MicroshopPageView.prototype.bindAddProductCheckboxes = function ($container) {
      var $saveButton = $container.parents('.tab_content').find('[data-form-save-button]');

      function checkParent($row) {
        var $productCheck = $row.find('[data-action-toggle-product]');
        var $variations = $row.find('[data-action-toggle-variation]');
        var isChecked = true;

        $variations.each(function () {
          if (!$(this).data('isChecked')) {
            isChecked = false;
            return false;
          }
        });

        checkElement($productCheck, isChecked);
      }

      function checkElement($el, check) {
        if ($el.data('isChecked') == check) return;

        $el.data('isChecked', check);
        $el.removeClass('icon-minus icon-plus').addClass(check ? 'icon-minus' : 'icon-plus');
      }

      function toggleAddVariant(isRemove, productNumber, variationNumber, $variationToggle) {
        if (isRemove) {
          delete _this.addProducts[variationNumber];
        } else {
          _this.addProducts[variationNumber] = {
            productNumber: productNumber,
            variationNumber: variationNumber
          };
        }

        checkElement($variationToggle, !isRemove);
      }

      $container.on('click', '[data-action-toggle-variation]', function (e) {
        var $variationToggle = $(this);
        var productNumber = $variationToggle.data('searchProduct');
        var variationNumber = $variationToggle.data('searchVariation');
        var isRemove = $variationToggle.data('isChecked');

        toggleAddVariant(isRemove, productNumber, variationNumber, $variationToggle);
        var $productRow = $variationToggle.parents('.cart-product');
        checkParent($productRow);
        $saveButton.attr('disabled', false);
      });

      $container.on('click', '[data-action-toggle-product]', function (e) {
        var $productToggle = $(this);
        var productNumber = $productToggle.data('searchProduct');
        var isRemove = $productToggle.data('isChecked');

        var $variations = $productToggle.parents('.cart-product').find('[data-action-toggle-variation]');
        $variations.each(function () {
          var $variation = $(this);

          var variationNumber = $variation.data('searchVariation');
          toggleAddVariant(isRemove, productNumber, variationNumber, $variation);
        });

        checkElement($productToggle, !isRemove);
        $saveButton.attr('disabled', false);
      });
    };

    //#endregion

    //#region THEME

    MicroshopPageView.prototype.initTheme = function () {
      _this.bindThemeSelects();
      _this.bindForm($('#themeForm'), MicroshopConnection.updateTheme);
    };

    MicroshopPageView.prototype.bindThemeSelects = function () {
      var $selects = $('[data-theme-select]');

      $selects.each(function () {
        $(this).on('change', function () {
          var main = $selects.filter('#Theme_Main').val();
          var accent = $selects.filter('#Theme_Accent').val();
          var lightness = $selects.filter('#Theme_Lightness').val();

          MicroshopConnection.getThemeColors(main, accent, lightness).then(function (res) {
            if (res && res.main) {
              _this.setTemplateThemeColors(res);
            }
          });
        });
      });
    };

    MicroshopPageView.prototype.setTemplateThemeColors = function (theme) {
      $('.theme-colors__header').css({
        background: theme.main.background,
        color: theme.main.text
      });

      $('.theme-colors__accent')
        .first()
        .css({
          background: theme.accent.background,
          color: theme.accent.text
        })
        .next()
        .css({
          background: theme.accentSpecial.background,
          color: theme.accentSpecial.text
        });

      $('.theme-colors__footer').css({
        background: theme.footer.background,
        color: theme.footer.text
      });
    };
    //#endregion

    //#region ORDERS, PRICES AND ADDON ARTICLES

    MicroshopPageView.prototype.initOrderSettings = function () {
      var $orderpricesettingsContainer = $('[data-orderpricesettings-container]');
      var $orderPriceRadio = $('[data-price-radio]:checked');

      _this.setDefaultPriceSettings($orderpricesettingsContainer);
      _this.bindPriceRadioChanged($orderpricesettingsContainer);
      _this.displayExtraPriceInputs($orderPriceRadio.val());

      _this.bindAddonChanged($orderpricesettingsContainer);
      _this.bindProductDeleted($orderpricesettingsContainer);
      _this.bindProductAdded($orderpricesettingsContainer);

      _this.bindForm($('#orderpricesettingsForm'), MicroshopConnection.updateOrderPriceSettings, function () {
        MicroshopConnection.getOrderPriceSettings(_this.shopId).then(function (res) {
          $orderpricesettingsContainer.html(res);
          _this.setDefaultPriceSettings($orderpricesettingsContainer);

          _this.displayExtraPriceInputs($orderpricesettingsContainer.find('[data-price-radio]:checked').val());
        });
      });
    };

    MicroshopPageView.prototype.setDefaultPriceSettings = function ($orderSettings) {
      var $priceSection = $orderSettings.find('[data-price-section]');

      _this.orderPriceSettings = {
        defaultPriceModelType: $priceSection.data('priceType'),
        defaultPriceFixed: $priceSection.data('priceFixed'),
        defaultPriceModifier: $priceSection.data('priceModifier')
      };
    };

    MicroshopPageView.prototype.bindProductAdded = function ($container) {
      $container.on('click', '[data-action-add="addon"]', function () {
        var $newRow = $(this).parents('.microshop-edit__tr');
        var $name = $newRow.find('[data-addon-new="name"]');
        var name = $name.val();
        if (!name) {
          toast.queueError($name.data('errorMsg'), 5000);
          return;
        }

        var number = $newRow.find('[data-addon-new="number"]').val();
        var price = $newRow.find('[data-addon-new="price"]').val();
        var type = $newRow.find('[data-addon-new="type"]').val();
        var inputType = $newRow.find('[data-addon-new="inputType"]').val();

        var index = $('[data-addon-row]').length;
        var indexName = 'ProductAddons[' + index + ']';

        var $templateClone = $('[data-addon-template]').clone();
        $templateClone
          .removeClass('microshop-edit__tr-template')
          .removeAttr('data-addon-template')
          .attr('data-addon-row', '');

        var $cloneName = $templateClone.find('[data-addon-hiddenname]');
        var $cloneStatus = $templateClone.find('[data-addon-status]');
        var $cloneNumber = $templateClone.find('[data-addon-number]');
        var $clonePrice = $templateClone.find('[data-addon-price]');
        var $cloneType = $templateClone.find('[data-addon-type]');
        var $cloneInputType = $templateClone.find('[data-addon-inputtype]');
        $templateClone.find('[data-addon-name]').text(name);

        _this.prepCloneInput($cloneName, indexName, name);
        _this.prepCloneInput($cloneStatus, indexName);
        _this.prepCloneInput($cloneNumber, indexName, number);
        _this.prepCloneInput($clonePrice, indexName, price);
        _this.prepCloneInput($cloneType, indexName, type);
        _this.prepCloneInput($cloneInputType, indexName, inputType);

        $newRow.parent().append($templateClone);
      });
    };

    MicroshopPageView.prototype.prepCloneInput = function ($el, indexName, val) {
      $el.prop('disabled', false).attr('name', $el.attr('name').replace('{{name}}', indexName));
      if (val) $el.val(val);
    };

    MicroshopPageView.prototype.bindAddonChanged = function ($container) {
      $container.on('change', '[data-addon-input]', function () {
        var $hiddenStatus = $(this).parents('.microshop-edit__tr').find('[data-addon-status]');

        // Set hidden status-input to changed.
        $hiddenStatus.val(1);
      });
    };

    MicroshopPageView.prototype.bindProductDeleted = function ($container) {
      $container.on('click', '[data-action-delete="addon"]', function (e) {
        var $row = $(this).parents('tr');

        // mark as deleted.
        $row.addClass('microshop-edit__deleted-tr');
        $(this).hide();

        // set hidden status-input to deleted
        $row.find('[data-addon-status]').val(2);
      });

      // If the product is not committed to the database yet we can just remove the row instead.
      $container.on('click', '[data-action-delete="newaddon"]', function (e) {
        $(this).parents('tr').remove();

        // deletes on uncommited products will mess up indices of other uncommited products so we update them.
        _this.updateAddonFormIndex();
      });
    };

    MicroshopPageView.prototype.updateAddonFormIndex = function (formData) {
      var regex = /\[(.*?)\]/;

      $('[data-addon-row]').each(function (i) {
        var $row = $(this);
        var $rowStatus = $row.find('[data-addon-status]');

        if ($rowStatus.val() !== 'Added') return;

        var $rowName = $row.find('[data-addon-hiddenname]');
        var $rowNumber = $row.find('[data-addon-number]');
        var $rowPrice = $row.find('[data-addon-price]');
        var $rowType = $row.find('[data-addon-type]');
        var $rowInputType = $row.find('[data-addon-inputtype]');

        $rowStatus.attr('name', $rowStatus.attr('name').replace(regex, '[' + i + ']'));
        $rowName.attr('name', $rowName.attr('name').replace(regex, '[' + i + ']'));
        $rowPrice.attr('name', $rowPrice.attr('name').replace(regex, '[' + i + ']'));
        $rowNumber.attr('name', $rowNumber.attr('name').replace(regex, '[' + i + ']'));
        $rowType.attr('name', $rowType.attr('name').replace(regex, '[' + i + ']'));
        $rowInputType.attr('name', $rowInputType.attr('name').replace(regex, '[' + i + ']'));
      });
    };

    MicroshopPageView.prototype.bindPriceRadioChanged = function ($container) {
      $container.on('change', '[data-price-radio]', function () {
        _this.displayExtraPriceInputs($(this).val());
      });
    };

    MicroshopPageView.prototype.displayExtraPriceInputs = function (selection) {
      var $fixedInput = $('[data-price-hidden-input="fixed"]');
      var $modifierInput = $('[data-price-hidden-input="modifier"]');

      switch (selection) {
        case '2':
          $fixedInput.show();
          $modifierInput.hide();
          break;
        case '3':
          $fixedInput.hide();
          $modifierInput.show();
          break;
        default:
          $fixedInput.hide();
          $modifierInput.hide();
          break;
      }
    };
    //#endregion

    return MicroshopPageView;
  })();

  return View('MicroshopPageView', function () {
    var view = new MicroshopPageView($('[data-view="MicroshopPageView"]'));
    view.init();
  });
});

